import { render, staticRenderFns } from "./points-rule-update.vue?vue&type=template&id=182a6a19&"
import script from "./points-rule-update.vue?vue&type=script&lang=js&"
export * from "./points-rule-update.vue?vue&type=script&lang=js&"
import style0 from "./points-rule-update.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports